import ApiService from '../../services/apiService';
import WGS84Service from '../../services/wgs84ProjectionService';
import { mapState } from 'vuex';
import get from 'lodash/get';
import MarkdownItVueLight from 'markdown-it-vue/dist/markdown-it-vue-light.umd.min.js';
export default {
  name: 'CoreFavdigitaltwin',
  components: {
    MarkdownItVueLight
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    tileSizeSetting: {
      type: Number,
      required: true,
      default: 0
    }
  },
  data() {
    return {
      twinDataStates: [],
      transparent: 'rgba(255, 255, 255, 0)',
      dtwin: null
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color']),
    cardLink() {
      const id = get(this.dtwin, 'id');
      if (!id) {
        // return no link if no id is available
        return null;
      }

      // get type and fallback to digitalTwin if not available
      const type = get(this.dtwin, 'properties.type', 'digitalTwin');
      return type === 'virtualDevice' ? `/virtual-devices/${id}` : `/digitaltwin-mgmt/${id}?dashboard`;
    },
    showMap() {
      if (get(this.dtwin, 'coordinates.coordinates[1]')) {
        return this.hasValidCoordinate;
      }
      return false;
    },
    dsize() {
      if (this.tileSizeSetting === 1) {
        return '-big';
      }
      return '';
    },
    headerBG() {
      let bigPicc = null;
      if (get(this.dtwin, 'data.twinImageId')) {
        bigPicc = `${process.env.VUE_APP_API_HOST}${process.env.VUE_APP_API_PATH}/upload/${this.dtwin.data.twinImageId}`;
      }
      return bigPicc ? bigPicc : './img/dtwin-factory1.png';
    },
    dtwinCoordinates() {
      return get(this.dtwin, 'coordinates.coordinates', [null, null]);
    },
    hasValidCoordinate() {
      const coordinate = {
        lat: this.dtwinCoordinates[1],
        lon: this.dtwinCoordinates[0]
      };
      return WGS84Service.isValidWgs84(coordinate);
    }
  },
  mounted() {
    this.digitalTwinGetData();
  },
  methods: {
    digitalTwinGetData() {
      ApiService.digitalTwinGet(this, this.item.objectId).then(data => {
        this.dtwin = data;
        if (!data || !data.id) {
          this.$emit('invalid');
        } else {
          this.loadStates();
        }
      }).catch(error => {
        if (get(error, 'response.data.message') === 'DTWIN_NOT_RIGHT_TYPE') {
          this.virtualDeviceGetData(this, this.item.objectId);
        }
      });
    },
    virtualDeviceGetData() {
      ApiService.virtualDeviceGet(this, this.item.objectId).then(data => {
        this.dtwin = data;
        if (!data || !data.id) {
          this.$emit('invalid');
        } else {
          this.loadStates();
        }
      }).catch(() => {
        // something happened, the twin does not exist any more, or user has no permission
        this.$emit('invalid');
      });
    },
    loadStates() {
      return ApiService.digitalTwinFetchStates(this, this.dtwin.id).then(twinDataStates => {
        this.twinDataStates = twinDataStates.map(state => {
          return Object.assign({}, state, {
            title: state.properties.title,
            unit: state.properties.unit,
            stateValue: state.value ? state.value.value : null,
            stateTime: state.value ? state.value.time : null
          });
        });
      }).catch(error => {
        console.error('Error reading twin states', error);
      });
    },
    pushToRouter(path, selected = null) {
      this.$router.push({
        path: path,
        query: {
          parent: selected ? selected.id : null,
          openTree: JSON.stringify(this.open)
        }
      });
    }
  }
};